module.exports = __webpack_public_path__ + "img/default.1f48e0e5.webp";